module.exports = __webpack_public_path__ + "static/media/sunbeam-card-image.0cb0a890.jpg";